import Vue from 'vue';
export default Vue.extend({
    data: function () { return ({
        siteKey: window.RECAPTCHA_SITE_KEY,
        widgetId: 0,
    }); },
    mounted: function () {
        if (this.siteKey) {
            this.waitForScript(this.render);
        }
    },
    methods: {
        render: function () {
            var _this = this;
            this.widgetId = window.grecaptcha.render(this.$refs.container, {
                sitekey: this.siteKey,
                size: 'invisible',
                'callback': function (response) {
                    _this.$nextTick(function () {
                        _this.$emit('verified', response);
                        _this.reset();
                    });
                },
                'callback-error': function (response) {
                    _this.$emit('failed', response);
                }
            });
        },
        verify: function () {
            if (!this.siteKey) {
                this.$emit('verified', 'No verification needed');
            }
            else {
                return window.grecaptcha.execute(this.widgetId);
            }
        },
        reset: function () {
            return window.grecaptcha.reset(this.widgetId);
        },
        /**
         * Wait for reCaptcha global object to be
         * present
         */
        waitForScript: function (callback) {
            var _this = this;
            if (typeof window.grecaptcha !== 'undefined') {
                callback();
            }
            else {
                setTimeout(function () {
                    _this.waitForScript(callback);
                }, 100);
            }
        }
    }
});
